import { useMemo } from 'react'

import { sectionsMap } from '@/components/sections'
import { pageHasHero } from '@/utils/page'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type BuilderProps = {
  pageProps?: WPPageData
}

const Builder = ({ pageProps }: BuilderProps) => {
  const hasHero = useMemo(
    () => (pageProps ? pageHasHero(pageProps) : false),
    [pageProps]
  )

  const builder = useMemo(() => {
    const sections = pageProps?.acf?.sections || []

    if (!hasHero && pageProps?.breadcrumbs) {
      return [
        { acf_fc_layout: 'spacer', variant: 'xs' },
        {
          acf_fc_layout: 'breadcrumbs',
          items: pageProps.breadcrumbs
        },
        { acf_fc_layout: 'spacer', variant: 'md' },
        ...sections
      ]
    }
    return sections
  }, [pageProps, hasHero])

  return (
    <>
      {builder.map(({ acf_fc_layout, theme, bgcolor, ...section }, index) => {
        const Section = sectionsMap[acf_fc_layout]

        return (
          <Section
            key={`section-${index}`}
            className={cn(['relative', { dark: theme === 'dark' }])}
            {...(acf_fc_layout.startsWith('hero') && {
              breadcrumbs: pageProps?.breadcrumbs
            })}
            {...(acf_fc_layout === 'hero_category' && {
              bgcolor: bgcolor || pageProps?.acf?.bgcolor
            })}
            theme={theme}
            {...section}
          />
        )
      })}
    </>
  )
}

export default Builder
